import React from 'react';
import { PagedUserProfileDto, UserServiceContractsDtosUserProfileDto } from 'api';
import styled from 'themed-components';
import { Box, Card, Grid, Typography, withStyles } from '@material-ui/core';

import _ from 'lodash';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { Pagination, Skeleton } from '@material-ui/lab';
const StyledCard = styled(Card)`
	padding: 0.5rem;
`;

export interface SupplierSearchResultsProps {
	data?: PagedUserProfileDto;
	loading: boolean;
	onChange: (entity?: UserServiceContractsDtosUserProfileDto) => void;
	selectedValue?: UserServiceContractsDtosUserProfileDto;
	setPage: (page: number) => void;
	currentPage: number;
}

const BoxWrapper = styled.div`
	padding: 0.25rem;
`;

const StyledToggleButtonGroup = withStyles((theme) => ({
	grouped: {
		style: {
			display: 'flex',
			flex: 1
		},
		'&': {
			flexDirection: 'column',
			flex: 1
		},

		'&.Mui-selected': {
			backgroundColor: theme.palette.primary.dark,
			color: theme.palette.primary.contrastText
		},
		'&:hover:not(.Mui-selected)': {
			backgroundColor: theme.palette.primary.light,
			color: theme.palette.primary.contrastText
		},
		'&:hover.Mui-selected': {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText
		}
	}
}))(ToggleButtonGroup);

const StyledSkeleton = styled(Skeleton)`
	padding-bottom: 0.1rem;
`;

const LoadingSkeleton = () => (
	<>
		<StyledSkeleton variant="rect" height={50} width="100%" />
		<StyledSkeleton variant="circle" width={80} height={80} />
		<StyledSkeleton variant="rect" height={218} width="100%" />
	</>
);

export const SupplierSearchResults = ({ data, loading, onChange, selectedValue, setPage, currentPage }: SupplierSearchResultsProps) => {
	const handleChangePage = (event: React.ChangeEvent<unknown>, newPage: number) => {
		setPage(newPage);
	};

	if (_.size(data) == 0 && !loading) return null;
	return (
		<Grid container direction="column" alignItems="flex-start">
			{loading && <LoadingSkeleton />}
			{!loading && (
				<Grid container item>
					<StyledToggleButtonGroup
						style={{ width: '100%' }}
						orientation="vertical"
						value={selectedValue?.entityId}
						exclusive
						color="primary"
						aria-label="supplier"
					>
						{_.map(data?.results || [], (d, i) => {
							const onToggleChange = () => onChange(d);
							return (
								<ToggleButton
									onClick={onToggleChange}
									key={`$supplierSearchResult${i}`}
									selected={selectedValue?.entityId == d.entityId}
									value={d.entityId}
									aria-label="address search results"
								>
									<Grid xs={12} container direction="column" alignItems="flex-start">
										<Box component={BoxWrapper}>{d.userDetail?.companyName}</Box>
										<Box component={BoxWrapper}>{d.userDetail?.businessName}</Box>
										<Box component={BoxWrapper}>{d.userDetail?.companyAbn || d.userDetail?.businessABN}</Box>
									</Grid>
								</ToggleButton>
							);
						})}
					</StyledToggleButtonGroup>
					<Grid xs={12} justify="flex-end" alignContent="flex-end" direction="row" container>
						<Pagination page={currentPage} count={data?.pageCount} color="primary" onChange={handleChangePage} />
					</Grid>
				</Grid>
			)}
		</Grid>
	);
};
